import type { FaireCollectionEntity } from "../../entity_types/collection";

export const col_confetti_cake: FaireCollectionEntity = {
  token: "col_confetti-cake",
  type: "collection",
  name: "Confetti & Cake",
  description:
    "Celebrate life's happiest moments with playful, giftable pieces made to become family traditions.",
  thumbnailUrl:
    "https://images.unsplash.com/photo-1558636508-e0db3814bd1d?w=400&h=400&fit=crop",
  heroImageUrl:
    "https://images.unsplash.com/photo-1558636508-e0db3814bd1d?w=1200&h=600&fit=crop",
  season: "new",
  itemCount: 24,
  brandToken: "catalog_brand_audreys_home_gift",
  productTokens: [],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
